export default __webpack_public_path__ + "src/assets/New_idea-bro.png";